import React from 'react';

import { TextCarousel } from '@gumtree/ui-library';
import GumshieldIcon from './gumshield.svg';
import { quotes, link } from './data.json';

const StaySafe = () => {
    return (
        <TextCarousel
            data={quotes}
            title="Stay Safe"
            link={link}
            icon={<GumshieldIcon />}
            endTracking="StaySafeEnd"
            linkTracking="StaySafeSeeAll"
            trackingContext="StaySafe"
        />
    );
};

export default StaySafe;
